import React from 'react';
import Icon from '../../components/Icon';
import Toast from 'react-native-root-toast';
import Theme from '../../theme'

const POSITION = 120;
const DURATION = 5000;

export const showError = (
  error: string,
  opacity = 0.8,
  ) => {
  Toast.show(error, {
    backgroundColor: Theme.RED,
    duration: DURATION,
    position: POSITION,
    textColor: Theme.WHITE,
    type: 'danger',
    opacity,
  });
};

export const showMessage = (
  message: string,
  opacity = 0.8,
  position = POSITION,
  ) => {
  Toast.show(message, {
    backgroundColor: Theme.BLACK,
    duration: DURATION,
    position: position,
    textColor: Theme.WHITE,
    opacity,
  });
};

export const showWarning = (
  warning: string,
  opacity = 0.8,
  ) => {
  Toast.show(warning, {
    backgroundColor: Theme.YELLOW,
    duration: DURATION,
    position: POSITION,
    textColor: Theme.WHITE,
    opacity,
  });
};

export const bookingCanceledToast = (dateText) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{fontSize: '25px', margin: '0 auto', maxWidth: '50vw'}}>You have successfully deleted your workout for <strong>{dateText}</strong>.</p>)
  };
}

export const partnerInvitedToast = (partnerName, slotTime) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{fontSize: '25px', margin: '0 auto', maxWidth: '50vw'}}>Invitation sent to <strong>{partnerName}</strong> for <strong>{slotTime}.</strong></p>)
  };
}

export const inviteCancelledToast = (dateText) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{fontSize: '25px', margin: '0 auto', maxWidth: '50vw'}}>Invite cancelled for <strong>{dateText}</strong></p>)
  };
}

export const addedToWaitingListToast = (dateText) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{fontSize: '25px', margin: '0 auto', maxWidth: '50vw'}}>Added to waiting list for <strong>{dateText}</strong></p>)
  };
}

export const removeFromWaitingListToast = (dateText) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{fontSize: '25px', margin: '0 auto', maxWidth: '50vw'}}>Removed from waiting list for <strong>{dateText}</strong></p>)
  };
}

export const partnerBlocked = (name) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{ fontSize: '25px', margin: '0 auto', maxWidth: '50vw' }}><strong>{name}</strong> blocked</p>)
  };
}

export const partnerUnblocked = (name) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{ fontSize: '25px', margin: '0 auto', maxWidth: '50vw' }}><strong>{name}</strong> unblocked</p>)
  };
}

export const partnerAdded = (name) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{ fontSize: '25px', margin: '0 auto', maxWidth: '50vw' }}><strong>{name}</strong> added</p>)
  };
}

export const partnerRemoved = (name) => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{ fontSize: '25px', margin: '0 auto', maxWidth: '50vw' }}><strong>{name}</strong> removed</p>)
  };
}

export const contactUs = () => {
  return {
    icon: (<Icon
      size={80}
      name="ios-checkmark-circle-outline"
      color={Theme.GREEN}
    />),
    text: (<p style={{ fontSize: '25px', margin: '0 auto', maxWidth: '50vw' }}>Thanks for your feedback</p>)
  };
}
